import { AuthState, AUTH_FEATURE_KEY } from './auth.reducers';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { getSelectedLayout } from '../app/app.selectors';
export const getAuthState = createFeatureSelector<AuthState>(AUTH_FEATURE_KEY);

export const getIsAuth = createSelector(
  getAuthState,
  state => state.isAuthenticated
);

export const getUser = createSelector(getAuthState, state => state.user);

export const getToken = createSelector(getAuthState, state => state.token);

export const getPermissions = createSelector(
  getUser,
  user => user?.permissions || []
);

export const getRole = createSelector(
  getPermissions,
  getSelectedLayout,
  (permissions, selectedLayout) =>
    permissions.find(x => x?.organization === selectedLayout?.organization)?.role
);
